"use strict";function t(t){return t&&"object"==typeof t&&"default"in t?t:{default:t}}var e=t(require("styled-components")).default.section`
    position: relative;
    .DXHowItWorks-image {
        display: block;
        position: absolute;
        width: 100%;
        height: 0;
        top: 0;
        padding-top: 104%;
        z-index: -1;
        max-width: 1440px;
        left: 50%;
        transform: translateX(-50%);

        @media (min-width: 992px) {
            width: 100%;
            height: 100%;
            padding: 0;
        }

        img {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
    .inner {
        display: grid;
        margin: 0 auto;
        > nav {
            display: none;
        }
        .DXHowItWorks-header {
            font-size: 34px;
            line-height: 40px;
            margin: 34px 0 69vw;
            text-align: center;
        }
    }
    .content {
        background: ${({theme:t})=>t.colors.common.light};
        box-shadow: ${({theme:t})=>t.shadows.high};
        box-sizing: border-box;
        height: 418px;
        margin: 0 auto;
        padding: 45px 25px;
        text-align: center;
        nav {
            align-items: center;
            display: flex;
            justify-content: center;
            button {
                background: transparent;
                border: none;
                outline: none;
                svg {
                    width: 17px;
                }
                &:first-of-type {
                    margin-right: 33px;
                    svg {
                        transform: rotate(180deg);
                    }
                }
                &:last-of-type {
                    margin-left: 33px;
                }
            }
        }
        span {
            align-items: center;
            background: ${({theme:t})=>t.colors.primary.dark};
            border-radius: 100%;
            color: ${({theme:t})=>t.colors.common.light};
            display: flex;
            font-family: ${({theme:t})=>t.fonts.secondary.fontFamily};
            font-size: 14px;
            height: 34px;
            justify-content: center;
            letter-spacing: normal;
            line-height: 22px;
            width: 34px;
        }
        .DXHowItWorks-contentTitle {
            font-family: ${({theme:t})=>t.fonts.primary.fontFamily};
            font-size: 22px;
            line-height: 26px;
            margin-top: 0;
        }
        .DXHowItWorks-content {
            font-family: ${({theme:t})=>t.fonts.secondary.fontFamily};
            font-size: 16px;
            line-height: 27px;
        }
        .DXHowItWorks-link {
            align-items: center;
            background: none;
            border-radius: 2px;
            color: ${({theme:t})=>t.colors.primary.default};
            cursor: pointer;
            display: flex;
            font-family: ${({theme:t})=>t.fonts.secondary.fontFamily};
            font-size: 12px;
            font-weight: 700;
            justify-content: center;
            letter-spacing: -0.3px;
            line-height: 15px;
            margin: 28px auto 0%;
            outline: none;
            padding-left: 0;
            position: relative;
            transition: all 0.4s ease-in-out 0s;
            width: max-content;
        }
    }
    @media screen and (min-width: 475px) {
        .inner {
            width: 86%;
        }
    }
    @media screen and (min-width: 992px) {
        .inner {
            max-width: 1224px;
            padding: 0 25px;
            width: unset;
            > nav {
                align-items: center;
                display: flex;
                justify-content: center;
                margin: 30px 0 60px;
                width: 100%;
                button {
                    align-items: center;
                    background: transparent;
                    border: none;
                    border-radius: 85px;
                    cursor: pointer;
                    display: inline-flex;
                    margin: 0 31px;
                    outline: none;
                    padding: 17px 29px 17px 16px;
                    transition: ${({loaded:t})=>t?"all 0.2s ease-in-out":"none"};
                    &.active {
                        background: ${({theme:t})=>t.colors.common.light};
                        span {
                            background: ${({theme:t})=>t.colors.primary.dark};
                            color: ${({theme:t})=>t.colors.common.light};
                        }
                    }
                    &:not(.active) {
                        &:hover,
                        &:active,
                        &:focus {
                            background: rgba(255, 255, 255, 0.4);
                        }
                    }
                    &:first-of-type {
                        margin-left: 0;
                    }
                    &:last-of-type {
                        margin-right: 0;
                    }
                    span {
                        align-items: center;
                        border: solid 1px
                            ${({theme:t})=>t.colors.primary.dark};
                        border-radius: 100%;
                        display: flex;
                        flex-direction: row;
                        justify-content: center;
                        height: 21px;
                        margin-right: 10px;
                        transition: ${({loaded:t})=>t?"all 0.2s ease-in-out":"none"};
                        width: 21px;
                    }
                }
            }
            .DXHowItWorks-header {
                margin: 83px 0 0;
            }
        }

        .content {
            margin: 0 auto 127px 0;
            max-width: 496px;
            padding: 71px 61px;
            text-align: left;
            nav {
                display: none;
            }
            .DXHowItWorks-link {
                margin: 28px auto 0 0;
            }
        }
        picture {
            height: 100%;
            padding: 0;
            width: 100%;
        }
    }
`;module.exports=e;
//# sourceMappingURL=styles.js.map
